import { render } from "./ScreenFinalVideo.vue?vue&type=template&id=585ba230&ts=true"
import script from "./ScreenFinalVideo.vue?vue&type=script&lang=ts"
export * from "./ScreenFinalVideo.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__